function calculateXAxis( {
	coordinates,
	overlay,
	viewport,
	horizontalOrientation,
} ) {
	let xTarget = coordinates.x;
	let remainingSpace;

	if ( horizontalOrientation === "LEFT" ) {
		// we need to get the "left corner" of the overlay, since LEFT
		// orientation is placing the right corner at the x coordinate
		let leftCorner = xTarget - overlay.width;
		if ( leftCorner < 0 ) {
			leftCorner = 0;
		}
		xTarget = leftCorner;
	} else {
		remainingSpace = viewport.width - ( xTarget + overlay.width );
		if ( remainingSpace < 0 ) {
			xTarget -= remainingSpace;
		}
	}
	return xTarget;
}

function calculateYAxis( {
	coordinates,
	overlay,
	viewport,
	verticalOrientation,
} ) {
	let yTarget = coordinates.y;
	let remainingSpace;

	if ( verticalOrientation === "BOTTOM" ) {
		remainingSpace = viewport.height - ( yTarget + overlay.height );
		if ( remainingSpace < 0 ) {
			yTarget += remainingSpace; // we're adding a negative, remember?
		}
	} else {
		// since we're wanting to show this towards the top
		// we need to calculate the bottom corner value
		yTarget -= overlay.height;
		if ( yTarget < 0 ) {
			yTarget = 0;
		}
	}
	return yTarget;
}

export function calculatePosition( {
	coordinates,
	overlay: _overlay,
	viewport,
	horizontalOrientation,
	verticalOrientation,
} ) {
	// If our overlay's dimensions are more than the current viewport
	// then we need to constrain it to fit within the viewport
	const overlay = {
		width: Math.min( _overlay.width, viewport.width ),
		height: Math.min( _overlay.height, viewport.height ),
	};

	const x = calculateXAxis( {
		coordinates,
		overlay,
		viewport,
		horizontalOrientation,
	} );

	const y = calculateYAxis( {
		coordinates,
		overlay,
		viewport,
		verticalOrientation,
	} );

	return { x, y, };
}
